module.exports = __webpack_public_path__ + "img/logo-white.2a65d194.png";